import * as Sentry from "@sentry/react";
import { ApiError, GlobalErrorWrapper } from "@wexinc/wex-common-web";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { Env } from "util/environment-helper";
import App from "./app/App";
import "./index.css";

Sentry.init({
  dsn: Env.sentryDSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.extraErrorDataIntegration({ depth: 10 }),
  ],
  normalizeDepth: 11,
  tracesSampleRate: 0.5,
  environment: Env.sentryEnvironment,
  // tag error with first error code for grouping in Sentry UI
  beforeSend(event, hint) {
    const originalError = hint.originalException;
    event.tags = event.tags || {};
    if (originalError instanceof ApiError && originalError.errorCodes?.length) {
      event.tags["primary_error_code"] = originalError.errorCodes[0];
    }
    return event;
  },
  // release tag MUST BE IDENTICAL here and in script/upload-source-maps.sh
  release: `${__APP_VERSION__}`,
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <GlobalErrorWrapper>
      <App />
    </GlobalErrorWrapper>
  </React.StrictMode>,
);
